import { c as _c } from "react/compiler-runtime";
import type { VaultKind } from '@onefootprint/request-types/dashboard';
import useFeaturePreview from '@/hooks/use-feature-preview';
import useAutoDecryptControls from '../../hooks/use-auto-decrypt-controls';
import DecryptForm from '../decrypt-form';
import { AuditTrail, AutoDecryptingMessage, Breadcrumb, ClassicOnboardings, Header, IncompleteBanner, Onboardings, PendingReviewBanner, PinnedNotes, Vault } from './components';
type ContentProps = {
  kind: VaultKind;
};
const Content = t0 => {
  const $ = _c(17);
  const {
    kind
  } = t0;
  const autoDecryptControls = useAutoDecryptControls(kind);
  const {
    isEnabled: isOnboardingsStripEnabled
  } = useFeaturePreview("onboardings_strip");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PendingReviewBanner />;
    t2 = <IncompleteBanner />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Breadcrumb />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== autoDecryptControls || $[4] !== kind) {
    t4 = autoDecryptControls.isEnabledForKind(kind) && <AutoDecryptingMessage expiresAt={autoDecryptControls.expiresAt} vaultKind={kind} />;
    $[3] = autoDecryptControls;
    $[4] = kind;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex flex-wrap gap-2 justify-between items-center md:flex-nowrap md:gap-0">{t3}{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PinnedNotes />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mt-3"><Header /></div>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mt-3 mb-10"><Vault /></div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mb-10"><AuditTrail /></div>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isOnboardingsStripEnabled) {
    t10 = <div className="mb-10">{isOnboardingsStripEnabled ? <Onboardings /> : <ClassicOnboardings />}</div>;
    $[12] = isOnboardingsStripEnabled;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t5) {
    t11 = <DecryptForm><section data-testid="entity-content" className="relative isolate">{t1}{t2}{t5}{t6}{t7}{t8}{t9}{t10}</section></DecryptForm>;
    $[14] = t10;
    $[15] = t5;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
export default Content;